<mat-toolbar color="primary" class="dialog-header">
  <mat-toolbar-row>
    <span class="dialog-title">{{ "pages.ckm-simulations.create" | translate }}</span>
    <span class="dialog-spacer"></span>
    <button mat-icon-button class="ml-auto" (click)="!loading ? closeDialog() : null">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<!-- Progress bar in caso di caricamento -->
<div class="dialog-loading" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</div>

<div class="dialog-body container">
  <app-ckm-simulation-create-stepper
    [projectId]="data.projectId"
    (stepChanged)="onStepChanged($event)"
    (generationStarted)="onGenerationStarted()"
    (generationCompleted)="onGenerationCompleted()"
    (navigation)="onNavigation($event)">
  </app-ckm-simulation-create-stepper>
</div>
